module.exports = __webpack_public_path__ + "static/media/detectDataImage8.7454bb2d.png";